var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 19,
  viewBox: "0 0 18 19",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17 17.667-4-3.89 4 3.89zM15.857 8.22c0 3.99-3.326 7.223-7.429 7.223C4.326 15.444 1 12.211 1 8.221 1 4.233 4.326 1 8.428 1c4.103 0 7.43 3.233 7.43 7.221z",
  stroke: "#252525",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export default ForwardRef;